
<app-layout>
  <router-view :key="$route.fullPath" />

  <ScreenshotGenerator />
</app-layout>
